import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import FixtureModel from "../../FixtureManagement/models/FixtureModel";
import FixtureSummaryModel from "../models/FixtureSummaryModel";
import MyFixtureQueryModel from "../models/MyFixtureQueryModel";

export interface SearchMyFixtureParam {
    pageSize: number,
    query: MyFixtureQueryModel
}

export interface GetMyFixtureSummaryParam {
    year: number,
}


const MyFixtureApi = {
    Search(param: SearchMyFixtureParam
        ) {
        return Api.post<SearchMyFixtureParam, BaseResponse<FixtureModel[]>>("/api/Fixture/SearchMyFixture", param);
    },
    GetMyFixtureSummary(param: GetMyFixtureSummaryParam) {
        return Api.get<GetMyFixtureSummaryParam, BaseResponse<FixtureSummaryModel>>("/api/Fixture/GetMyFixtureSummary", param);
    },
};
export default MyFixtureApi;